module.exports = __webpack_public_path__ + "static/img/6.b2a9ac8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/eng/6.png
// module id = miyv
// module chunks = 0